import { observer } from 'mobx-react';
import React from 'react';
import { Link } from 'react-router-dom';

import { CALENDAR_MAX_SHIPPING_PRICE } from '../../../constants/processors';
import CalendarCheckoutStore from '../../../store/CalendarCheckoutStore';


function ShippingCost(props) {
  const { shippingCostsLoading, finalProduct, error } = CalendarCheckoutStore;

  const renderMessage = () => {
    if (finalProduct.product.details.shipping > CALENDAR_MAX_SHIPPING_PRICE) {
      return (
        <div>
          Your shipping costs exceeds the maximum allowed. Please{' '}
          <Link to="/contact">contact us</Link> for details.
        </div>
      );
    }

    return (
      <div>
        Your shipping and handling costs is{' '}
        {finalProduct.product.details.shipping}
        {finalProduct.product.currency.symbol}. Total amount is{' '}
        {(
          finalProduct.product.details.shipping + finalProduct.product.amount
        ).toFixed(2)}
        {finalProduct.product.currency.symbol}.
      </div>
    );

  };
  console.log(finalProduct);

  return (
    <div className="shippingCost">
      {shippingCostsLoading && <div>Estimating your shipping costs…</div>}
      {finalProduct && renderMessage()}
      {error && !shippingCostsLoading && (
        <p className="error-text">
          Sorry an error has occurred: {error.replace(/_/g, ' ')}. Please{' '}
          <a href="/contact">contact customer support</a> for details.
        </p>
      )}
    </div>
  );
}

export default observer(ShippingCost);
